export default "__VITE_ASSET__Cn2jb6VP__"